import styled from 'styled-components'

export default styled.div`
  overflow-y: auto;
  padding: 12px 0;
  height: ${document.body.clientHeight - 52}px;
  
  .title-container {
    width: 100%;
    text-align: center;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 20px;
    margin: 40px 0;
  }

  .order-container {
    box-shadow: none;
    margin: 0 18px;
    border-top: 1px solid #ececec;

    &:before {
      content: none;
    }

    &:last-child {
      border-bottom: 1px solid #ececec;
    }
  };

  .order-summary {
    height: 92px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 12px;
    color: #767676;

    > div {
      display: block;
    }

    h5 {
      color: #1d1d1d;
      font-size: 14px;
    }
  }

  .order-details {
    display: block;
    border-top: 1px solid #ececec;
  }

  .qrcode-container {
    width: 200px;
    margin: 39px auto 0;

    .qrcode {
      padding: 15px;
      user-select: none;
    }
  }

  .qr-code-message-container {
    margin-top: 9px;
    margin-bottom: 40px;

    .qrcode_message {
      /* width: 335px; */
      margin: auto;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 9px;
      line-height: 1.4em;
      letter-spacing: -0.2px;
      text-align: center;
      color: #000000;

      html[lang=tw] & {
        font-size: 12px;
      }
    }
  }

  .order-details-container {
    width: 89.3%;
    margin: 43px auto 0;
    text-align: center;
    color: #000000;

    .thank-you-title {

      font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
      font-size: 20px;
      font-weight: normal;
      line-height: 1.2;
      letter-spacing: -0.5px;

      html[lang=tw] & {
        font-size: 24px;
      }
    }

    .ticket-no-label, .collect-message {
      margin-left: auto;
      margin-right: auto;
      width: 70%;

      font-family: 'ABChanel PB Regular M', Arial, sans-serif;
      font-size: 9px;
      letter-spacing: -0.02em;

      html[lang=tw] & {
        font-size: 12px;
      }
    }

    .collect-message {
      margin-top: 13px;
      margin-bottom: 30px;
    }

    .ticket-no-label {

    }

    .ticket-no {
      font-family: 'ABChanel PB Regular M', Arial, sans-serif;
      font-size: 48px;
      line-height: 1.2em;
      letter-spacing: -1.2px;
    }

    .qrcode-container {
      margin-top: 4px;
    }
  }

  .checkout-container {
    /* margin-top: 106px;
    margin-top: 19.2vh; */

    .customer-name {
      margin: 12px auto 80px;
      /* width: 335px; */
      height: 12px;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 9px;
      letter-spacing: -0.2px;
      text-align: center;
      color: #000000;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/OrderHistory.js